import { Routes } from '@angular/router';
import { quineAppHostGuard } from './guards/quine-app-host.guard';

export const routes: Routes = [
  {
    path: 'v2',
    canActivate: [quineAppHostGuard],
    loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.dashboardRoutes)
  },
  {
    path: '',
    loadChildren: () => import('./marketing/marketing.routes').then(m => m.marketingRoutes)
  }
];
